<template>
  <div v-if="markers.length" class="bottomRouge">
    <gmap-map
      class="infoBorder gmap"
      :center="{
        lat: markers[0].latitude,
        lng: markers[0].longitude,
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="mapPanneauxLc"
      @tilesloaded="levelZoom">
      <gmap-marker
        v-for="(m, index) in markers"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude,
        }"
        @click="afficheFace(m)"
        @mouseover="handleMarkerHover(m, index)"
        :icon="m.icon">
      </gmap-marker>
      <gmap-marker
        v-if="markerFaceLc.lat"
        :position="{
          lat: markerFaceLc.lat,
          lng: markerFaceLc.lng,
        }"
        :icon="markerFaceLc.icon">
      </gmap-marker>

      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
        <div v-html="infoContent"></div>
      </gmap-info-window>
    </gmap-map>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-opportunites :bg="bg" :detailFaceLc="detailFaceLc" v-if="show"/>
    </transition>
  </div>
</template>

<script>
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import fullscreenPopupMixin from '@/services/general/fullscreenPopupMixin';
import detailOpportunites from './detailOpportunites';

export default {
  name: 'cartePanneauxLc',
  mixins: [fullscreenPopupMixin],
  props: ['markers', 'markerFaceLc'],
  components: {
    appDetailOpportunites: detailOpportunites,
  },
  data() {
    return {
      moyLat: 0,
      moyLng: 0,
      centreCarte: {},
      detailFaceLc: {},
      show: false,
      bg: false,
      isLoadOnce: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  methods: {
    afficheFace(m) {
      this.detailFaceLc = m;
      this.show = true;
    },
    async levelZoom() {
      if (this.markers.length && !this.isLoadOnce) {
        const bounds = new google.maps.LatLngBounds();
        filterLatLng(this.markers);
        this.markers.forEach(m => {
          if (m.latitude !== 0 && m.longitude !== 0
          && m.latitude !== null && m.longitude !== null) {
            bounds.extend({ lat: m.latitude, lng: m.longitude });
          }
        });
        if (this.markerFaceLc !== undefined && this.markerFaceLc.lat !== undefined) {
          bounds.extend({ lat: this.markerFaceLc.lat, lng: this.markerFaceLc.lng });
        }
        this.$refs.mapPanneauxLc.fitBounds(bounds);
        this.isLoadOnce = true;
      }
    },
    getInfoWindowContent(marker) {
      const adresse = this.buildAdresse(marker);

      return (
        `<div style="padding:15px" class="card">
          <div class="">
            <div class="columns">
              <div class="column is-6">
                <p>Code Face : <strong>${marker.code || ''}</strong></p>
                <p>Adresse : <strong>${adresse}</strong></p>
                <p>Format : <strong>${marker.format || ''}</strong></p>
              </div>
              <div class="column">
                <img style="width:100%"
                    src="${marker.urlPhoto ? marker.urlPhoto : this.defaultPlaceholder}"/>
              </div>
            </div>
          </div>
        </div>`);
    },
  },
  async mounted() {
    const map = await this.$refs.mapPanneauxLc.$mapPromise;
    const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
      name: MAP_TYPE_NAME,
    });
    map.mapTypes.set('styled_map', styleMap);
    this.setupFullscreenListeners();
  },
  beforeDestroy() {
    this.removeFullscreenListeners();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/panneauxLc/cartePanneauxLc.vue